module.exports = __webpack_public_path__ + "img/no_data.69c47927.png";